import { Button, Theme } from '@mui/material';
import styled, { css, CSSObject } from 'styled-components';

import { getThemeValue } from '@/shared/components/ui/button/common/button-common.styled';

import { TStyledTextButtonProps } from './text-button.types';

// Variant style mappings
const VARIANT_STYLES = {
  primary: {
    typography: 'button1',
    color: 'primary.main',
    hoverColor: 'primary.dark',
  },
  secondary: {
    typography: 'button2',
    color: 'secondary.dark',
    hoverColor: 'secondary.main',
  },
  primaryLighter: {
    typography: 'button2',
    color: 'primary.main',
    hoverColor: 'primary.dark',
  },
  primaryUnderlined: {
    typography: 'button3',
    color: 'primary.main',
    hoverColor: 'primary.dark',
  },
  alert: {
    typography: 'button1',
    color: 'danger.main',
    hoverColor: 'danger.dark',
  },
  alertSecondary: {
    typography: 'button2',
    color: 'danger.main',
    hoverColor: 'danger.dark',
  },
  alertUnderlined: {
    typography: 'button3',
    color: 'danger.main',
    hoverColor: 'danger.dark',
  },
} as const;

// Reusable style mixins
const iconStyles = css<TStyledTextButtonProps>`
  height: 1.25rem !important;
  width: 1.25rem !important;
  color: inherit;
`;

const getVariantStyles = (theme: Theme, variant = 'primaryUnderlined') => {
  const styles = VARIANT_STYLES[variant as keyof typeof VARIANT_STYLES];
  const typographyStyle = theme.typography[styles.typography];

  return css`
    ${typographyStyle as CSSObject};
    color: ${getThemeValue(theme, styles.color)};

    svg {
      ${iconStyles};
    }

    &:hover {
      background: transparent;
      color: ${getThemeValue(theme, styles.hoverColor)};
      ${typographyStyle as CSSObject};

      svg {
        color: ${getThemeValue(theme, styles.hoverColor)};
      }
    }

    &:disabled {
      color: ${theme.palette.text.disabled};

      svg {
        color: ${theme.palette.text.disabled};
      }
    }
  `;
};

// Main styled components
export const StyledTextButton = styled(Button)<TStyledTextButtonProps>`
  && {
    ${({ $variant, theme }) => getVariantStyles(theme as Theme, $variant)};
    background: transparent;
    padding: 0;
    gap: 0.375rem;
    min-width: unset;
    text-wrap: nowrap;
  }
`;
